import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getUsers, resetPassword, softDeleteUser } from '../../Services/UserService';
import { InputSwitch } from 'primereact/inputswitch';
import Swal from 'sweetalert2';
import MTable from '../../Components/MTable/MTable';
import { toastError, toastSuccess } from "../../Components/Toasts/Toast";
import { uuid } from '../../Utils/Utils';
import EditButton from '../../Components/Button/EditButton';
import CustomButton from '../../Components/Button/CustomButton';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { getRoles } from '../../Services/RoleService';
import { setModuleName } from '../../Stores/Action/AppAction';

const UserScreen = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const mTable = useRef();

  const [state, setState] = useState({
    options: []
  });

  const onEdit = item => () => {
    navigate("edit/" + item._id);
  };

  const onResetPassword = item => () => {
    Swal.fire({
      icon: 'question',
      title: 'Are you sure',
      text: 'Reseted password can not be restored',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
    }).then(({ isConfirmed }) => {
      if (isConfirmed) {
        Swal.fire({
          title: 'Input the new password here!',
          input: 'password',
          showCancelButton: true,
          confirmButtonText: 'Reset'
        }).then(({ value }) => {
          resetPassword(item._id, { password: value }).then(res => {
            //toastSuccess('Reset password success');
            Swal.fire({
              icon: 'success',
              title: 'Reset Password',
              text: 'Reset password success'
            }).then(mTable.current.refresh())
          }).catch(({ response: { err } }) => {
            //toastError('Reset password failed');
            Swal.fire({
              icon: 'error',
              title: 'Reset Password',
              text: 'Reset password failed'
            }).then(mTable.current.refresh())
          });
        })
      }

    });
  };

  const columns = [
    { id: uuid(), title: 'NIK', field: 'nik', sortable: true },
    {
      id: uuid(),
      title: 'Avatar',
      sortable: false,
      render: data => {
        return <div>{(data.avatar != '' ?  <img src={process.env.REACT_APP_OBS_URL + data.avatar} style={{ width: 32, height: 32, objectFit: 'cover' }} /> : '')}</div>;
      },
  },
    { id: uuid(), title: 'Full Name', field: 'full_name', sortable: true },
    { id: uuid(), title: 'User Name', field: 'username', sortable: true },
    { id: uuid(), title: 'Email', field: 'email', sortable: true },
    {
      id: uuid(),
      title: 'Role',
      sortable: false,
      render: data => {
        return data.role.role_name;
      },
    },
    {
      id: uuid(),
      title: 'Active',
      field: 'is_active',
      sortable: true,
      options: [
        {
          label: 'Active',
          value: true
        },
        {
          label: 'Inactive',
          value: false
        }
      ],
      render: data => {
        return <InputSwitch checked={data.is_active} onChange={(e) => changeStatus(data._id, e.value)} />;
      },
    },
    {
      id: uuid(),
      title: 'Action',
      sortable: false,
      render: item => {
        return (
          <div>
            <EditButton title="Edit" onClick={onEdit(item)} />
            {
              ((item.email || '').indexOf('@modena.com') == -1) && (
                <CustomButton title="Reset Password" type="danger" icon="fas fa-key" onClick={onResetPassword(item)} />
              )
            }

          </div>
        );
      },
    },
  ];

  const onAddData = () => {
    navigate("add/new");
  }

  const changeStatus = (username, status) => {
    const body = {
        is_active: status
    }

    softDeleteUser(username, body, res => {
          if (res.status == 200 || res.status == 201) {
              Swal.fire({
                  icon: 'success',
                  title: 'Change status success',
                  text: 'Data has been changed!'
              }).then(res => { mTable.current.refresh(); });
          }
      }, error => {
          Swal.fire({
              icon: 'error',
              title: 'Change status fail',
              text: 'Data can not be changed!'
          });
      });
  }

  useEffect(() => {
    dispatch(setModuleName('Users'));
    getRoles({ perpage: 1000 }, ({ data }) => {
      const _options = data.data.map(item => {
        return {
          label: item.role_name,
          value: item.role_name
        }
      });

      setState({ ...state, options: _options });
    });
  }, []);

  //const propsTable = { columns, getData: getSkuAll, showIndex: true, showAddButton: userInfo.access.sku_config.can_create, onAddData, enableFilter: true, filterRule: 'filter', orders: 'id_sub_category:asc' };
  const propsTable = { defaultSort: '_id', columns, getData: getUsers, showIndex: true, showAddButton: true, onAddData, enableFilter: true, filterRule: 'filter' };

  return (
    <div className="content-wrapper">
      <div className="content-header">
      </div>
      <section className="content">
        <div className="container-fluid">
          <div className="row">
            <div className='col-12'>
              <div className='card'>
                <div className='card-header'>
                  <div className='card-title'><i className='fa fa-user-tag' /> List User</div>
                </div>
                <div className='card-body'>
                  <MTable ref={mTable} {...propsTable} order="full_name" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default UserScreen;